<template>
    <v-navigation-drawer
      app
      disable-resize-watcher
      fixed
      v-model="drawer"
      width="300"
    >
        <v-toolbar>
            <v-list>
                <v-list-item-content>
                    <v-list-item-title class="title">Store Space</v-list-item-title>
                </v-list-item-content>
            </v-list>
        </v-toolbar>

        <v-list dense>
            <v-list-item
                data-testid="drawer-dashboard-link"
                class="drawer-dashboard-link"
                :to="`/`"
            >
                <v-list-item-action>
                    <v-icon>home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Dashboard</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-group
                v-show="isSuperAdmin || userRoles.includes('Facility Manager')"
                prepend-icon="business"
                :value="currentNav.indexOf('facilities') > -1 || currentNav.indexOf('features') > -1"
            >
                <template v-slot:activator>
                    <v-list-item-title>Facilities</v-list-item-title>
                </template>

                <v-list-item
                    data-testid="drawer-facilities-index-link"
                    class="drawer-facilities-index-link"
                    :to="{ name: 'facilitiesIndex' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Manage Facilities</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    data-testid="drawer-facility-features-index-link"
                    class="drawer-facility-features-index-link"
                    :to="{ name: 'facilityFeaturesIndex' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Manage Features</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <v-list-group
                    v-show="navigationViewAccess"
                    prepend-icon="web"
                    :value="navigationMenuValues"
            >
                <template v-slot:activator>
                    <v-list-item-title>Website</v-list-item-title>
                </template>

                <v-list-group
                    v-show="isSuperAdmin || userRoles.includes('Content Manager')"
                    no-action
                    sub-group
                    :value="superAdminAndContentValues"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Content</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-content-pages-index-link"
                        class="drawer-content-pages-index-link"
                        :to="{ name: 'contentPagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Content Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-static-pages-index-link"
                        class="drawer-static-pages-index-link"
                        :to="{ name: 'staticPagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Static Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-state-pages-index-link"
                        class="drawer-state-pages-index-link"
                        :to="{ name: 'statePagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage State Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-city-pages-index-link"
                        class="drawer-city-pages-index-link"
                        :to="{ name: 'cityPagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage City Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-alt-cities-pages-index-link"
                        class="drawer-alt-cities-pages-index-link"
                        :to="{ name: 'altCitiesPagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Alt Cities Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <!-- help center -->
                <v-list-group
                    v-show="userRoles.includes('Super Admin') || userRoles.includes('Content Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('helpcenter') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Help Center</v-list-item-title>
                    </template>

                    <v-list-item
                      data-testid="drawer-help-center-categories-link"
                      class="drawer-help-center-categories-link"
                      :to="{ name: 'helpCenterCategories' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Categories</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-help-center-entries-link"
                        class="drawer-help-center-entries-link"
                        :to="{ name: 'helpCenterEntries' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Entries</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin || userRoles.includes('Content Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('landing') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>PPC</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-landing-pages-index-link"
                        class="drawer-landing-pages-index-link"
                        :to=" { name: 'landingPagesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Landing Pages</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin || userRoles.includes('SEO Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('redirects') > -1 || currentNav.indexOf('robots') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>SEO</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-redirects-index-link"
                        class="drawer-redirects-index-link"
                        :to="{ name: 'redirectsIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Redirects</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-show="isSuperAdmin" :to="{ name: 'robotsIndex' }">
                        <v-list-item-content>
                            <v-list-item-title>Manage Robots.txt</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('navigation') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Navigation</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-header-navigation-link"
                        class="drawer-header-navigation-link"
                        :to="{ name: 'headerNavigationIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Header Nav</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-footer-navigation-link"
                        class="drawer-footer-navigation-link"
                        :to="{ name: 'footerNavigationIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Footer Nav</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('global') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Global Settings</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-global-attributes-index-link"
                        class="drawer-global-attributes-index-link"
                        :to="{ name: 'globalUnitAttributesIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Default Unit Attributes</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-global-settings-index-link"
                        class="drawer-global-settings-index-link"
                        :to="{ name: 'globalSettingsIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Global Settings</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                  <v-list-item
                    data-testid="drawer-global-incentives-index-link"
                    class="drawer-global-incentives-index-link"
                    :to="{ name: 'globalIncentivesIndex' }"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Manage Global Incentives</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin || userRoles.includes('Facility Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('reviews') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Reviews</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-reviews-approval-index-link"
                        class="drawer-reviews-approval-index-link"
                        :to="{ name: 'reviewsApprovalIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Reviews</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="isSuperAdmin || userRoles.includes('Gift Card Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('gift') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Promotions</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-gift-cards-index-link"
                        class="drawer-gift-cards-index-link"
                        :to="{ name: 'giftCardsIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Gift Cards</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-group
                    v-show="userRoles.includes('Super Admin') || userRoles.includes('Survey Manager')"
                    no-action
                    sub-group
                    :value="currentNav.indexOf('surveys') > -1"
                >
                    <template v-slot:activator>
                        <v-list-item-title>Surveys</v-list-item-title>
                    </template>

                    <v-list-item
                        data-testid="drawer-surveys-index-link"
                        class="drawer-surveys-index-link"
                        :to="{ name: 'surveysIndex' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Manage Surveys</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                        data-testid="drawer-surveys-responses-link"
                        class="drawer-surveys-responses-link"
                        :to="{ name: 'surveysResponses' }"
                    >
                        <v-list-item-content>
                            <v-list-item-title>Survey Responses</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
            </v-list-group>

            <v-list-item
              data-testid="drawer-blacklist-index-link"
              class="drawer-blacklist-index-link"
              :to="{ name: 'blacklistIndex' }"
              v-show="isSuperAdmin || userRoles.includes('Facility Manager')"
            >
              <v-list-item-action>
                <v-icon>no_accounts</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Do Not Rent</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
                v-show="isSuperAdmin"
                prepend-icon="assignment_ind"
                :value="currentNav.indexOf('accountability') > -1"
            >
                <template v-slot:activator>
                    <v-list-item-title>Accountability Assistant</v-list-item-title>
                </template>

                <v-list-item
                    data-testid="drawer-acct-assistant-settings-link"
                    class="drawer-acct-assistant-settings-link"
                    :to="{ name: 'accountabilityAssistantSettings' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Manage Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <v-list-group
                v-show="isSuperAdmin"
                prepend-icon="settings_remote"
                :value="currentNav.indexOf('ace') > -1"
            >
                <template v-slot:activator>
                    <v-list-item-title>ACE</v-list-item-title>
                </template>

                <v-list-item
                    data-testid="drawer-ace-dashboard-link"
                    class="drawer-ace-dashboard-link"
                    :to="{ name: 'aceDashboard' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Dashboard</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    data-testid="drawer-ace-settings-link"
                    class="drawer-ace-settings-link"
                    :to="{ name: 'aceSettings' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Manage Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

<!--                <v-list-item-->
<!--                    data-testid="drawer-ace-scheduler-link"-->
<!--                    class="drawer-ace-scheduler-link"-->
<!--                    :to="{ name: 'aceScheduler' }" -->
<!--                    v-show="userRoles.includes('Super Admin')"-->
<!--                >-->
<!--                    <v-list-item-action>-->
<!--                        &nbsp;-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>Manage Manual Emails</v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
            </v-list-group>

            <v-list-group
                v-show="isSuperAdmin"
                prepend-icon="tablet"
                :value="currentNav.indexOf('managertablet') > -1"
            >
                <template v-slot:activator>
                    <v-list-item-title>Manager Tablet</v-list-item-title>
                </template>

                <v-list-item
                    data-testid="drawer-manager-tablet-settings-link"
                    class="drawer-manager-tablet-settings-link"
                    :to="{ name: 'managerTabletSettings' }"
                >
                    <v-list-item-action>
                        &nbsp;
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Manage Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-group>

            <v-list-item
                data-testid="drawer-users-index-link"
                class="drawer-users-index-link"
                :to="{ name: 'usersIndex' }"
                v-show="isSuperAdmin || userRoles.includes('User Manager')"
            >
                <v-list-item-action>
                    <v-icon>people</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Manage Users</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item
                data-testid="drawer-activity-log-link"
                class="drawer-activity-log-link"
                :to="{ name: 'activityLog' }"
                v-show="isSuperAdmin"
            >
                <v-list-item-action>
                    <v-icon>list_alt</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Activity Log</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      drawerExpanded: state => state.app.applicationSettings.drawerExpanded,
      currentNav: state => state.app.currentNav,
      userProfile: state => state.user.profile
    }),

    drawer: {
      get() {
        return this.drawerExpanded;
      },
      set(newValue) {
        this.$store.dispatch("toggleDrawer", newValue);
      }
    },

    navigationViewAccess() {
      return this.userRoles.includes("Super Admin") || this.userRoles.includes("Facility Manager") ||
                this.userRoles.includes("Content Manager") || this.userRoles.includes("SEO Manager") ||
                this.userRoles.includes("Survey Manager") || this.userRoles.includes("Gift Card Manager");
    },

    navigationMenuValues() {
      return this.currentNav.indexOf("content") > -1 || this.currentNav.indexOf("landing") > -1 ||
                   this.currentNav.indexOf("static") > -1 || this.currentNav.indexOf("state") > -1 ||
                   this.currentNav.indexOf("city") > -1 || this.currentNav.indexOf("alt") > -1 ||
                   this.currentNav.indexOf("redirects") > -1 || this.currentNav.indexOf("robots") > -1 ||
                   this.currentNav.indexOf("global") > -1 || this.currentNav.indexOf("navigation") > -1 ||
                   this.currentNav.indexOf("reviews") > -1 || this.currentNav.indexOf("gift") > -1 ||
                   this.currentNav.indexOf("survey") > -1 || this.currentNav.indexOf("helpcenter") > -1;
    },

    superAdminAndContentValues() {
      return this.currentNav.indexOf("content") > -1 || this.currentNav.indexOf("static") > -1 ||
                   this.currentNav.indexOf("state") > -1 || this.currentNav.indexOf("city") > -1 || this.currentNav.indexOf("alt") > -1;
    },

    isSuperAdmin() {
      return this.userRoles.includes("Super Admin");
    },

    userRoles() {
      // User roles legend: 1 = Super Admin, 3 = User Manager, 5 = Facility Manager, 7 = Content Manager, 9 = SEO Manager, 19 = Gift Card Manager
      if (this.userProfile && this.userProfile.allowed_navigation && this.userProfile.allowed_navigation.length) {
        return this.userProfile.allowed_navigation;
      } else {
        return [];
      };
    }
  }
};
</script>
